const busersTypes = {

  get: {
    request: "GET_BUSER_REQUEST",
    success: "GET_BUSER_SUCCESS",
    failure: "GET_BUSER_FAILURE"
  },

  index: {
    request: "BUSERS_INDEX_REQUEST",
    success: "BUSERS_INDEX_SUCCESS",
    failure: "BUSERS_INDEX_FAILURE",
    select:  "BUSERS_INDEX_SELECT"
  },

  create: {
    init:    "CREATE_BUSER_INIT",
    request: "CREATE_BUSER_REQUEST",
    success: "CREATE_BUSER_SUCCESS",
    failure: "CREATE_BUSER_FAILURE"
  },

  update: {
    request: "UPDATE_BUSER_REQUEST",
    success: "UPDATE_BUSER_SUCCESS",
    failure: "UPDATE_BUSER_FAILURE"
  },

  // activate: {
  //   request: "BUSER_OPERATION_REQUEST",
  //   success: "BUSER_OPERATION_SUCCESS",
  //   single: "BUSER_OPERATION_SINGLE_SUCCESS",
  //   failure: "BUSER_OPERATION_FAILURE"
  // },
  //
  // deactivate: {
  //   request: "BUSER_OPERATION_REQUEST",
  //   success: "BUSER_OPERATION_SUCCESS",
  //   single: "BUSER_OPERATION_SINGLE_SUCCESS",
  //   failure: "BUSER_OPERATION_FAILURE"
  // },


  set_errors: "SET_BUSER_ERRORS",

  reset_buser: "RESET_BUSER",

  clear_buser: "CLEAR_BUSER",

}

export default busersTypes



// WEBPACK FOOTER //
// ./src/js/constants/busersTypes.js